var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.91024C3 4.36049 3.3347 3.86612 3.84514 3.66194L7.25722 2.29711C7.73404 2.10638 8.26596 2.10638 8.74278 2.29711L12.1549 3.66194C12.6653 3.86612 13 4.36049 13 4.91024V6.39029C13 9.25014 11.4995 11.9003 9.04721 13.3717C8.40263 13.7584 7.59737 13.7584 6.95279 13.3717C4.50049 11.9003 3 9.25014 3 6.39029V4.91024Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.23a47152c98e3ee5bc9545bf2d6fc482.svg";
export { ForwardRef as ReactComponent };